import React from "react";

export const StepDot = ({ active, done, label }) => (
    <span
        className="inline-flex items-center justify-center w-6 h-6 rounded-full text-[10px] font-bold"
        style={{
            background: done ? "#4A7C59" : active ? "#002D62" : "#e6ded1",
            color: done || active ? "white" : "#4a5648",
        }}
    >
        {done ? "✓" : label}
    </span>
);

export const CField = ({ label, value, onChange, type = "text", testId, required }) => (
    <div>
        <label className="block text-xs uppercase tracking-wider font-bold text-earth-600 mb-2">
            {label}
            {required && <span className="text-terracotta-500"> *</span>}
        </label>
        <input
            data-testid={testId}
            type={type}
            value={value ?? ""}
            onChange={(e) => onChange(e.target.value)}
            required={required}
            className="w-full bg-earth-50 border border-earth-200 rounded-xl px-4 py-3 outline-none focus:border-terracotta-500"
        />
    </div>
);
